import { APICall } from "@/config/NetworkUtility";
import { getErrorPayload } from "@/utils/reduxError";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getRolePermissions = createAsyncThunk(
    "navigationRolePermissions/getRolePermissions",
    async (payload, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams(payload).toString();

            const response = await APICall(
                "get",
                {},
                `/v1/NavigationSetup/GetNavigationRolePermissionList?${queryParams}`,
            );

            if ([200, 201].includes(response?.statuscode)) {
                return response.data ?? [];
            }

            return rejectWithValue({
                status: response?.statuscode,
                message: response?.message ?? "Failed to load role permissions.",
                data: response?.data ?? null,
            });
        } catch (error) {
            return rejectWithValue(getErrorPayload(error));
        }
    },
);

export const saveNavigationRolePermissionProcess = createAsyncThunk(
    "navigationRolePermissions/navigationRolePermissionProcess",
    async (treeData, { rejectWithValue }) => {
        try {
            const formData = new FormData();

            formData.append("JsonStringValue", JSON.stringify(treeData));

            const result = await APICall(
                "post",
                formData,
                "v1/NavigationSetup/NavigationRolePermissionProcess",
            );

            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result;
            }

            return rejectWithValue(result);
        } catch (error) {
            return rejectWithValue(getErrorPayload(error));
        }
    },
);

export const getUserPermissions = createAsyncThunk(
    "navigationRolePermissions/getUserPermissions",
    async (payload, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams(payload).toString();

            const response = await APICall(
                "get",
                {},
                `/v1/NavigationSetup/GetNavigationUserPermissionList?${queryParams}`,
            );

            if ([200, 201].includes(response?.statuscode)) {
                return response.data ?? [];
            }

            return rejectWithValue({
                status: response?.statuscode,
                message: response?.message ?? "Failed to load user permissions.",
                data: response?.data ?? null,
            });
        } catch (error) {
            return rejectWithValue(getErrorPayload(error));
        }
    },
);

export const saveUserNavigationRolePermissionProcess = createAsyncThunk(
    "navigationRolePermissions/userNavigationRolePermissionProcess",
    async (treeData, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("JsonStringValue", JSON.stringify(treeData));

            const response = await APICall(
                "post",
                formData,
                "v1/NavigationSetup/NavigationUserPermissionProcess",
            );

            if ([200, 201].includes(response?.statuscode)) {
                return {
                    status: response.statuscode,
                    message: response.message,
                    data: response.data,
                };
            }

            return rejectWithValue({
                status: response?.statuscode,
                message:
                    response?.message ?? "Failed to save user navigation permissions.",
                data: response?.data ?? null,
            });
        } catch (error) {
            return rejectWithValue(getErrorPayload(error));
        }
    },
);
